/* eslint valid-jsdoc: "error" */

/**
 * Набір «вікон» для відображення сезонних/акційних блоків.
 * Формати:
 * - ['DD.MM','DD.MM']  — річне вікно (підтримує перетин року)
 * - { start:'DD.MM', end:'DD.MM' } — те саме, іншим записом
 * - ['YYYY-MM-DD','YYYY-MM-DD'] — одноразове вікно
 * - { start:'YYYY-MM-DD', end:'YYYY-MM-DD' } — те саме, іншим записом
 */
export const DATE = Object.freeze({
	HALLOWEEN: [ '25.10', '01.11' ], // щороку 22 жовтня — 1 листопада
	WINTER: { start: '01.12', end: '05.01' }, // щороку 1 грудня — 10 січня (перетин року)
	// WINTER: { start: '01.12', end: '10.12' }, // щороку 1 грудня — 10 січня (перетин року)

	// SUMMER_2026: { start: '01.07', end: '31.08' },
});
